import { Link } from "react-router-dom"

import { Header } from "shared/components/organisms/Header/Header"
import { Sidebar } from "shared/components/organisms/Sidebar/Sidebar"

import { ReactComponent as LeftArrow } from 'assets/icons/left-arrow.svg'

import { Article, CardTitle, Container, Content } from "./_whoWeAre"

export const WhoWeAre = () => {
  return (
    <Container>
      <Header />
      <Sidebar />

      <Content>
        <Link
          className="who-content__icon-container"
          to="/perfil"
        >
          <LeftArrow
            className="who-content__icon"
          />
        </Link>

        <CardTitle>
          <h1 className="who-card__title">
            Quem somos
          </h1>
        </CardTitle>
          <Article>
            {`A REPFY é uma empresa fundada por experientes profissionais do ramo de serviços, com grande expertise em atendimento ao cliente.

            O Intuito da REPFY é tornar-se referência como plataforma de contratação de serviços gerais, unir o profissional e o cliente de forma segura, rápida e prática.

            Para que isso fosse possível, contamos com talentosos desenvolvedores, que junto a experientes profissionais de serviços, uniram a expertise da logística e vivência em campo, com beleza de um código inteligente.Acreditamos na empatia e experiência, como chave para realização de trabalhos com qualidade e excelência.  Quer saber mais sobre a gente? Fale no e-mail contato@repfy.com.br, ou visite nosso site www.repfy.com.br.
                `}
          </Article>
      </Content>
    </Container>
  )
}
